import MembersPage from "../../features/dashboard/members/MembersPage";

function MembersDB() {
  return <MembersPage />;
}

export default MembersDB;
